/**
 * Web stub for react-native-simple-dialogs
 */
import React, { FC, ReactNode } from 'react';

interface DialogProps {
  visible?: boolean;
  title?: string;
  message?: string;
  buttons?: Array<{ text: string; onPress?: () => void }>;
  children?: ReactNode;
  [key: string]: any;
}

const Dialog: FC<DialogProps> = ({ visible, title, message, buttons, children }) => {
  if (!visible) {
    return null;
  }

  const buttonElements = buttons
    ? buttons.map((btn, idx) =>
        React.createElement(
          'button',
          {
            key: idx,
            onClick: btn.onPress,
            style: {
              padding: '8px 16px',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer',
              background: '#007AFF',
              color: 'white',
            },
          },
          btn.text
        )
      )
    : null;

  return React.createElement(
    'div',
    {
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      },
    },
    React.createElement(
      'div',
      {
        style: {
          background: 'white',
          borderRadius: '8px',
          padding: '20px',
          maxWidth: '300px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
        },
      },
      title && React.createElement('h2', { style: { margin: '0 0 10px 0', fontSize: '18px' } }, title),
      message && React.createElement('p', { style: { margin: '0 0 15px 0', color: '#666' } }, message),
      children,
      buttonElements &&
        React.createElement(
          'div',
          { style: { display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' } },
          buttonElements
        )
    )
  );
};

export { Dialog };
export default Dialog;
